export const STATUS = {
  pending: 'Pendente',
  approved: 'Confirmada',
  cancelled: 'Cancelada',
  expired: 'Expirada',
  refunded: 'Estornada',
  refund_pending: 'Estorno pendente',
};

export default STATUS;
